//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register"

//LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login"
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login"
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd"
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd"
export const SOCIAL_LOGIN = "/social-login"

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
export const POST_EDIT_PROFILE = "/post-fake-profile"
// Campaign

export const GET_ALL_CAMPAING = "admin/campaign/all"
export const ADD_CAMPAING = "admin/campaign/add"
// CUSTOMERS
export const GET_ALL_CUSTOMERS = "admin/customer/all"
export const GET_CUSTOMERS_LIST = "admin/customer/list"
export const GET_CUSTOMER_DETAILS = "admin/customer/details"
export const UPDATE_CUSTOMER_STATUS = "admin/customer/details/update-status"
export const UPDATE_CUSTOMER = "admin/customer/details/update"
export const DELETE_CUSTOMER = "admin/customer/delete"
export const CUSTOMER_LOYALTY_POINTS = "admin/common/loyalty-points/all"
export const ADD_LOYALTY_POINTS = "admin/common/loyalty-points/add"
export const REVOKE_LOYALTY_POINTS = "admin/common/loyalty-points/deduct"
export const PAYMENT_HISTORY = "admin/common/payment-history/all"
export const WALLET_HISTORY = "admin/common/wallet-transactions/all"
export const APP_VERSIONS = "admin/common/app/versions"

// AUTH USER
export const USER_DETAILS = "auth/regenerate-token"
export const USER_AUTH_DETAILS = "auth/details"
export const USER_DETAIL_UPDATE = "auth/details/update"
export const VALIDATE_UUID = "auth/validate-uuid"
export const NEW_USER_RESET_PASSWORD = "auth/new-user/reset-password"

// USERS
export const GET_ALL_USERS = "admin/user/all"
export const GET_USER_DETAILS = "admin/user/details"
export const ADD_ADMIN_USER = "admin/user/add"
export const UPDATE_ADMIN_USER = "admin/user/details/update"
export const UPDATE_ADMIN_USER_STATUS = "admin/user/details/update-status"
export const DELETE_ADMIN_USER = "admin/user/delete"
export const GET_BRANCH_LIST = "admin/branch/list"
export const GET_ROLES_LIST = "admin/roles/list"
export const UPDATE_USER_PASSWORD = "auth/details/update-password"
export const GET_USERS_LIST = "admin/user/list"

// BRANCH/LOCATIONS
export const GET_ALL_BRANCHES_LIST = "admin/branch/all"
export const GET_BRANCH_DETAILS = "admin/branch/details"
export const UPDATE_BRANCH_STATUS = "admin/branch/details/update-status"
export const DELETE_BRANCH = "admin/branch/delete"
export const ADD_BRANCH = "admin/branch/add"
export const UPDATE_BRANCH = "admin/branch/details/update"
export const UPDATE_MULTIPLES_BRANCH = "admin/branch/details/update-multiple"
export const COPY_BRANCH_SETTINGS = "admin/branch/details/copy-settings"
export const GENERATE_BRANCH_ID = "admin/branch/generate-id"
export const CLONE_BRANCH = "admin/branch/clone"

// BANNERS
export const GET_ALL_BANNERS_LIST = "admin/banner/all"
export const ADD_BANNER = "admin/banner/add"
export const GET_BANNER_DETAILS = "admin/banner/details"
export const UPDATE_BANNER = "admin/banner/details/update"
export const DELETE_BANNER = "admin/banner/delete"
export const UPDATE_BANNER_STATUS = "admin/banner/details/update-status"
// SLIDES
export const GET_SLIDE_DETAILS = "admin/slide/details"
export const UPDATE_SLIDE_STATUS = "admin/slide/details/update-status"
export const DELETE_SLIDE = "admin/slide/delete"
export const ADD_SLIDE = "admin/slide/add"
export const UPDATE_SLIDE = "admin/slide/details/update"

// CATEGORIES
export const GET_ALL_CATEGORIES_LIST = "admin/category/all"
export const GET_CATEGORY_DETAILS = "admin/category/details"
export const UPDATE_CATEGORY_STATUS = "admin/category/details/update-status"
export const DELETE_CATEGORY = "admin/category/delete"
export const ADD_CATEGORY = "admin/category/add"
export const UPDATE_CATEGORY = "admin/category/details/update"
// ITEMS
export const GET_ALL_ITEMS = "admin/item/all"
export const UPDATE_ITEM_STATUS = "admin/item/details/update-status"
export const ADD_ITEM = "admin/item/add"
export const GET_ITEM_DETAILS = "admin/item/details"
export const UPDATE_ITEM = "admin/item/details/update"
export const DELETE_ITEM = "admin/item/delete"
export const GET_ALL_ITEMS_DROPDOWN = "admin/item/list"
export const GET_B2C_ITEMS_DROPDOWN = "admin/item/b2c-list"
export const GET_CATEGORIES = "admin/category/list"
export const GET_B2C_CATEGORIES = "admin/category/e-store/list"
export const DELETE_MULTIPLE_ITEMS = "admin/item/delete-multiple"
export const UPDATE_MULTIPLE_ITEMS = "admin/item/details/update-multiple"
export const ITEM_CATEGORIES = "admin/category/itemCategories"
export const ADD_GALLERY_IMAGES = "admin/item/gallery-upload"
export const ADD_VIDEO = "admin/item/video-upload"
export const CLONE_ITEM = "admin/item/clone"
export const ENABLE_DISABLE_ITEM = "admin/item/details/enable-disable-item"
// COMBO
export const CALCULATE_COMBO_PRICE = "admin/item/calculate-price"

// MODIFIER GROUPS
export const GET_ALL_MODIFIER_GROUPS = "admin/modifier-group/all"
export const ADD_MODIFIER_GROUP = "admin/modifier-group/add"
export const DELETE_MODIFIER_GROUP_FROM_ITEM =
  "admin/modifier-group/delete-from-item"
export const GET_ALL_MODIFIER_GROUPS_LIST = "admin/modifier-group/list" //GET API
export const GET_MODIFIER_GROUP_DETAILS = "admin/modifier-group/details"
export const UPDATE_MODIFIER_GROUP = "admin/modifier-group/details/update"
export const UPDATE_MODIFIER_GROUP_STATUS =
  "admin/modifier-group/details/update-status"
export const DELETE_MODIFIER_GROUP = "admin/modifier-group/delete"

// MODIFIERS
export const GET_ALL_MODIFIER = "admin/modifier/all"
export const GET_ALL_MODIFIER_LIST = "admin/modifier/list"
export const UPDATE_MODIFIER_STATUS = "admin/modifier/details/update-status"
export const DELETE_MODIFIER = "admin/modifier/delete"
export const GET_MODIFIER_DETAILS = "admin/modifier/details"
export const ADD_MODIFIER = "admin/modifier/add"
export const UPDATE_MODIFIER = "admin/modifier/details/update"
export const ENABLE_DISABLE_MODIFIER =
  "admin/modifier/details/enable-disable-modifier"

// ITEM GROUPS
export const GET_ALL_ITEM_GROUPS = "admin/item-group/all"
export const GET_ITEM_GROUPS_LIST = "admin/item-group/list"
export const GET_ITEM_GROUP_DETAILS = "admin/item-group/details"
export const UPDATE_ITEM_GROUPS_STATUS =
  "admin/item-group/details/update-status"
export const DELETE_ITEM_GROUP = "admin/item-group/delete"
export const ADD_ITEM_GROUP = "admin/item-group/add"
export const UPDATE_ITEM_GROUP = "admin/item-group/details/update"

// Menu Setup
export const ADD_MENU_SETUP = "admin/menu-setup/add"
export const GET_ALL_MENU_SETUP = "admin/menu-setup/list"
export const GET_MENU_SETUP = "admin/menu-setup/get"
export const UPDATE_MENU_SETUP = "admin/menu-setup/update"
export const DELETE_MENU_SETUP = "admin/menu-setup/soft-delete"
export const MENU_WITHOUT_PAGINATION = "admin/menu-setup/names"
export const MENU_BY_COUNTRY_AND_BRAND = "admin/menu-setup/by-country-brand"

// COUNTRIES
export const GET_ALL_COUNTRIES = "admin/country/all"
export const UPDATE_COUNTRY_STATUS = "admin/country/details/update-status"
export const GET_ALL_COUNTRY_LIST = "admin/country/list"
export const GET_COUNTRY_DETAILS = "admin/country/details"
export const DELETE_COUNTRY = "admin/country/delete"
export const UPDATE_COUNTRY = "admin/country/update"
export const ADD_COUNTRY = "admin/country/add"
export const UPDATE_TENANT_COUNTRY_TAX_SHIPMENT =
  "admin/tenant-country-assignments/tax-shipment"

// REGION
export const GET_ALL_REGION_LIST = "admin/region/list"
export const GET_ALL_REGIONS = "admin/region/all"
export const GET_REGION_DETAILS = "admin/region/details"
export const UPDATE_REGION = "admin/region/details/update"
export const DELETE_REGION = "admin/region/delete"
export const UPDATE_REGION_STATUS = "admin/region/details/update-status"
export const ADD_REGION = "admin/region/add"

// CITY
export const GET_ALL_CITY_LIST = "admin/city/list"
export const GET_CITY_DROPDOWN_LIST = "admin/city/dropdown-list"
export const GET_ALL_CITY = "admin/city/all"
export const GET_CITY_DETAILS = "admin/city/details"
export const UPDATE_CITY_DETAILS = "admin/city/details/update"
export const DELETE_CITY = "admin/city/delete"
export const UPDATE_CITY_STATUS = "admin/city/details/update-status"
export const ADD_CITY = "admin/city/add"

//ZONE
export const ADD_ZONE = "admin/zone/add"
export const DELETE_ZONE = "admin/zone/delete"
export const GET_ALL_ZONE = "admin/zone/all"
export const GET_ALL_ZONE_LIST = "admin/zone/list"
export const GET_ZONE_DETAILS = "admin/zone/details"
export const UPDATE_ZONE_DETAILS = "admin/zone/details/update"
export const UPDATE_ZONE_STATUS = "admin/zone/details/update-status"

export const GET_ALL_MENUS = "admin/menu/all"
export const UPDATE_MENU_STATUS = "admin/menu/details/update-status"
export const GET_ALL_MENU_LIST = "admin/menu/list"
export const GET_MENU_DETAILS = "admin/menu/details"
export const DELETE_MENU = "admin/menu/delete"
export const UPDATE_MENU = "admin/menu/update"
export const ADD_MENU = "admin/menu/add"

export const GET_BRAND_NAMES_LIST = "admin/brand/brand-names/list"
export const GET_ALL_BRAND_LIST = "admin/brand/list"
export const GET_ALL_BRANDS = "admin/brand/all"
export const ADD_BRAND = "admin/brand/add"
export const GET_BRAND_DETAILS = "admin/brand/details"
export const UPDATE_BRAND = "admin/brand/update"
export const DELETE_BRAND = "admin/brand/delete"
export const UPDATE_BRAND_STATUS = "admin/brand/status"
export const TOGGLE_BRAND = "admin/brand/toggle"
export const VERIFY_BRAND = "admin/brand/verify"
export const GET_ASSIGNED_BRANDS = "admin/brand/assigned"
export const SET_DEFAULT_BRAND = "admin/brand/set-default"

// COMMON
export const USER_ACTIVITY = "admin/common/user-activity"
export const USER_ACTIVITY_DETAILS = "admin/common/user-activity/details"
export const EXPORT_DATA = "admin/common/export-data"
export const BRANCH_COUNTRY = "admin/common/branch-country/list"
export const COMMON_DATA = "admin/common/commonData"

// B2C ROUTES
export const GET_ALL_B2C_SALES_REPORTS = "admin/reports/b2c-sales"
export const GET_ALL_B2C_SUMMARY_SALES_REPORTS =
  "admin/reports/b2c-summary-sales"

// ORDERS
export const GET_ALL_ORDERS = "admin/orders/all"
export const GET_ORDER_DETAILS = "admin/orders/details"
export const ORDER_STATUS_UPDATE = "admin/orders/update-status"
export const UPDATE_ORDER_DELIVERY_DATE = "admin/orders/update-delivery-date"
export const ASSIGN_ORDERS_TO_RIDER = "admin/orders/assign-to-rider"
export const ASSIGN_ORDERS_TO_BRANCH = "admin/orders/assign-to-branch"
export const RIDERS_FOR_ASSIGNMENT = "admin/delivery-partners/list-for-assignment"
export const RIDER_PENDING_ORDERS_COUNT = "admin/delivery-partners"
export const SYNC_ORDER_WITH_POS = "admin/orders/syncOrderWithPOS"
export const SYNC_ORDER_WITH_SALASA = "admin/orders/sendOrderToSalasa"

// TAX
export const GET_TAX_DETAILS = "admin/system-settings/taxes/details"
export const UPDATE_TAX_DETAILS = "admin/system-settings/taxes/details/update"

// DASHBOARD
export const DASHBOARD_KPI = "admin/common/dashboard-kpi"
export const DASHBOARD_KPI_ORDER = "admin/common/dashboard-kpi/orders"
export const DASHBOARD_KPI_BOOKING = "admin/common/dashboard-kpi/bookings"
export const DASHBOARD_KPI_RATINGS = "admin/common/dashboard-kpi/ratings"
export const EDIYAH_DASHBOARD = "admin/common/dashboard-kpi/gift-cards"
export const WALLET_DASHBOARD = "admin/common/dashboard-kpi/wallet"
export const ESTORE_DASHBOARD = "admin/common/dashboard-kpi/estore"
export const MARKETING_DASHBOARD = "admin/common/dashboard-kpi/marketing"
export const LOYALTY_DASHBOARD = "admin/common/dashboard-kpi/loyalty-points"

// LOGS
export const API_LOGS = "admin/common/api-logs/all"
export const API_LOG_DETAILS = "admin/common/api-logs/details"

// RATINGS
export const GET_ALL_RATINGS = "admin/ratings/all"
export const GET_ALL_QUESTIONS = "admin/ratings/questions/all"
export const GET_QUESTION_DETAILS = "admin/ratings/questions/details"
export const UPDATE_QUESTION_STATUS =
  "admin/ratings/questions/details/update-status"
export const DELETE_QUESTION = "admin/ratings/questions/delete"
export const ADD_QUESTION = "admin/ratings/questions/add"
export const UPDATE_QUESTION = "admin/ratings/questions/update"

export const GET_ALL_BRANCH_RATINGS = "admin/ratings/branch/feedbacks"
export const GET_BRANCH_RATINGS_DETAILS =
  "admin/ratings/branch/feedbacks/details"

// PROMOTIONS
export const GET_ALL_PROMOTIONS = "admin/coupon-promotion/all"
export const GET_ALL_PROMOTIONS_LISTS = "admin/coupon-promotion/list"
export const GET_PROMOTIONS_DETAILS = "admin/coupon-promotion/details"
export const ADD_PROMOTION = "admin/coupon-promotion/add"
export const UPDATE_PROMOTION = "admin/coupon-promotion/details/update"
export const UPDATE_PROMOTION_STATUS =
  "admin/coupon-promotion/details/update-status"
export const DELETE_PROMOTION = "admin/coupon-promotion/delete"
// COUPON GROUPS
export const GET_ALL_COUPON_GROUPS = "admin/coupon-group/all"
export const GET_ALL_COUPON_GROUPS_LIST = "admin/coupon-group/list"
export const GET_COUPON_GROUP_DETAILS = "admin/coupon-group/details"
export const ADD_COUPON_GROUP = "admin/coupon-group/add"
export const UPDATE_COUPON_GROUP = "admin/coupon-group/details/update"
export const UPDATE_COUPON_GROUP_STATUS =
  "admin/coupon-group/details/update-status"
export const DELETE_COUPON_GROUP = "admin/coupon-group/delete"
export const UPDATE_BULK_COUPON_GROUP = "admin/coupon/details/update-bulk"
// COUPON
export const GET_ALL_COUPONS = "admin/coupon/all"
export const GET_ALL_COUPONS_LIST = "admin/coupon/list"
export const GET_COUPON_DETAILS = "admin/coupon/details"
export const ADD_COUPON = "admin/coupon/add"
export const ADD_BULK_COUPONS = "admin/coupon/add-bulk"
export const UPDATE_COUPON = "admin/coupon/details/update"
export const UPDATE_COUPON_STATUS = "admin/coupon/details/update-status"
export const DELETE_COUPON = "admin/coupon/delete"

// COUPON REDEEM
export const GET_ALL_WALLET_COUPONS = "admin/coupon-redeem/all"
export const GET_WALLET_COUPON_DETAILS = "admin/coupon-redeem/details"
export const ADD_WALLET_COUPON = "admin/coupon-redeem/add"
export const UPDATE_WALLET_COUPON = "admin/coupon-redeem/details/update"
export const UPDATE_WALLET_COUPON_STATUS =
  "admin/coupon-redeem/details/update-status"
export const DELETE_WALLET_COUPON = "admin/coupon-redeem/delete"

// COUPON USAGE
export const COUPON_USAGE = "admin/coupon-usage/all"
export const COUPON_USAGE_DETAILS = "admin/coupon-usage/details"

//GLOBAL SETTINGS
export const GLOBAL_SETTINGS = "admin/system-settings/global"
export const UPDATE_GLOBAL_SETTING = "admin/system-settings/global/update"
export const PAYMENT_METHODS_SCOPE = "admin/system-settings/payment-methods/scope"
export const DELIVERY_PROFILES_SCOPE = "admin/system-settings/delivery-profiles/scope"
export const CLEAR_MENU_CACHE = "admin/system-settings/clearRedisCache"

// PUSH NOTIFICATION
export const GET_ALL_PUSH_NOTIFICATIONS = "admin/push-notification/all"
export const GET_PUSH_NOTIFICATION_DETAILS = "admin/push-notification/details"
export const UPDATE_PUSH_NOTIFICATION_STATUS =
  "admin/push-notification/details/update-status"
export const UPDATE_PUSH_NOTIFICATION = "admin/push-notification/details/update"

export const SEND_NOTIFICATION = "admin/push-notification/broadcast"
export const GET_NOTIFICATION_HISTORY =
  "admin/push-notification/messages/history"
export const DELETE_SCHEDULE_NOTIFICATION =
  "admin/push-notification/messages/delete"

// CUSTOMER SUPPORT
export const GET_ALL_ISSUE_TYPE = "admin/support/issue-type/all"
export const UPDATE_ISSUE_TYPE_STATUS =
  "admin/support/issue-type/details/update-status"
export const DELETE_ISSUE_TYPE = "admin/support/issue-type/delete"
export const ADD_ISSUE_TYPE = "admin/support/issue-type/add"
export const GET_ISSUE_TYPE_DETAILS = "admin/support/issue-type/details"
export const UPDATE_ISSUE_TYPE_DETAILS =
  "admin/support/issue-type/details/update"
export const ISSUE_TYPE_DROPDOWN_LISTS = "admin/support/issue-type/list"

export const GET_ALL_SUPPORT_TICKET = "admin/support/tickets/all"
export const GET_TICKET_DETAILS = "admin/support/tickets/details"
export const UPDATE_TICKET_STATUS =
  "admin/support/tickets/details/update-status"
export const UPDATE_BULK_TICKET_STATUS =
  "admin/support/tickets/details/update-multiple-status"

// INGREDIENT
export const GET_ALL_INGREDIENTS_LIST = "admin/ingredient/list"
export const GET_ALL_INGREDIENTS = "admin/ingredient/all"
export const UPDATE_INGREDIENT_STATUS = "admin/ingredient/details/update-status"
export const GET_INGREDIENT_DETAILS = "admin/ingredient/details"
export const DELETE_INGREDIENT = "admin/ingredient/delete"
export const ADD_INGREDIENT = "admin/ingredient/add"
export const UPDATE_INGREDIENT = "admin/ingredient/details/update"
// ITEM TAGS
export const GET_ALL_ITEM_TAGS_LIST = "admin/item-tag/list"
export const GET_ALL_ITEM_TAGS = "admin/item-tag/all"
export const GET_ITEM_TAG_DETAILS = "admin/item-tag/details"
export const UPDATE_ITEM_TAG_STATUS = "admin/item-tag/details/update-status"
export const DELETE_ITEM_TAG = "admin/item-tag/delete"
export const ADD_ITEM_TAG = "admin/item-tag/add"
export const UPDATE_ITEM_TAG = "admin/item-tag/details/update"
// ALLERGEN
export const GET_ALL_ALLERGENS_LIST = "admin/allergen/list"
export const GET_ALL_ALLERGEN = "admin/allergen/all"
export const GET_ALLERGEN_DETAILS = "admin/allergen/details"
export const UPDATE_ALLERGEN_STATUS = "admin/allergen/details/update-status"
export const DELETE_ALLERGEN = "admin/allergen/delete"
export const ADD_ALLERGEN = "admin/allergen/add"
export const UPDATE_ALLERGEN = "admin/allergen/details/update"
// STATIC MAINTENANCE
export const GET_ALL_STATIC_MAINTENANCE_LIST = "admin/static-maintenance/list"
export const GET_ALL_STATIC_MAINTENANCE = "admin/static-maintenance/all"
export const DELETE_STATIC_MAINTENANCE = "admin/static-maintenance/delete"
export const ADD_STATIC_MAINTENANCE = "admin/static-maintenance/add"
export const UPDATE_STATIC_MAINTENANCE =
  "admin/static-maintenance/details/update"
export const GET_STATIC_MAINTENANCE_DETAILS = "admin/static-maintenance/details"

// REPORTS
export const GET_ALL_SALES_REPORTS = "admin/reports/sales"

export const GET_PAYMENTS_METHOD_REPORTS = "admin/reports/payment-methods"
export const GET_BUSINESS_TAX_REPORTS = "admin/reports/business-tax"
export const GET_LOYALTY_POINTS_REPORTS = "admin/reports/loyalty-points"
export const GET_GIFT_CARD_REPORT = "admin/reports/gift-cards"
export const GET_PREMIUM_GIFT_CARD_REPORT = "admin/reports/premium-gift-cards"
export const GET_WALLET_REPORT = "admin/reports/wallet-report"
export const GET_WALLET_TRANSFER_REPORT = "admin/reports/wallet-transfer-report"
export const GET_WALLET_PURCHASE_REPORT = "admin/reports/wallet-purchase-report"

// FAQ
export const GET_ALL_FAQ = "admin/page-content/all"
export const ADD_FAQ = "admin/page-content/add"
export const GET_FAQ_DETAILS = "admin/page-content/details"
export const UPDATE_FAQ = "admin/page-content/details/update"
export const DELETE_FAQ = "admin/page-content/delete"
export const UPDATE_FAQ_STATUS = "admin/page-content/details/update-status"
export const GET_PAGE_CONTENT_BY_TYPE = "admin/page-content/get-by-type"
export const UPDATE_PAGE_CONTENT_BY_TYPE = "admin/page-content/update-by-type"
// BOOKINGS
export const GET_ALL_BOOKINGS = "admin/booking/all"
export const GET_BOOKING_DETAILS = "admin/booking/details"
export const DELETE_BOOKING = "admin/booking/delete"
export const UPDATE_BOOKING_STATUS = "admin/booking/details/update-status"

// QR CODE
export const QR_CODE_GENERATE = "admin/common/dynamiclink/create"
export const SAVE_DYNAMIC_LINK = "admin/common/dynamiclink/save"

// EXPORT REQUEST
export const EXPORT_REQUEST = "admin/common/export-requests"

// POS SETTINGS
export const GET_POS_COUNTRY_LISTS = "admin/posSettings/countryLists"
export const UPDATE_API_KEY = "admin/posSettings/updateApiKey"
export const POS_MENU_SYNC = "admin/posSettings/syncMenuItems"
export const FETCH_POS_DISCOUNTS = "admin/posSettings/getDiscountPrograms"
export const FETCH_POS_BRANCHES = "admin/posSettings/getALLBranches"
export const GET_POS_BRANCH_DETAILS = "admin/posSettings/getBranchDetails/"
export const SYNC_POS_BRANCH = "admin/posSettings/syncBranches"

// PUBLIC
export const PUBLIC_PRIVACY_POLICY = "admin/page-content/public/PrivacyPolicy"
export const PUBLIC_TERMS_CONDITIONS =
  "admin/page-content/public/TermsAndConditions"

// VEHICLE
export const GET_ALL_VEHICLES = "admin/vehicles/all"
export const ADD_VEHICLE = "admin/vehicles/Add"
export const UPDATE_VEHICLE = "admin/vehicles/details/update"
export const GET_VEHICLE_DETAILS = "admin/vehicles/details"
export const UPDATE_VEHICLE_STATUS = "admin/vehicles/details/update-status"
export const DELETE_VEHICLE = "admin/vehicles/delete"

// GIFT CARD
export const GET_ALL_GIFT_CARDS = "admin/gift-cards/all"
export const ADD_GIFT_CARD = "admin/gift-cards/add"
export const UPDATE_GIFT_CARD = "admin/gift-cards/details/update"
export const GET_GIFT_CARD_DETAILS = "admin/gift-cards/details"
export const DELETE_GIFT_CARD = "admin/gift-cards/delete"
export const UPDATE_GIFT_CARD_STATUS = "admin/gift-cards/details/update-status"
export const GET_GIFT_CARD_LIST = "admin/gift-cards/list"
export const GET_PREMIUM_GIFT_CARD_LIST = "admin/gift-cards/premium-list"
export const GET_GIFT_CARD_LIST_BY_CARD_TYPE =
  "admin/gift-cards/get-by-cardType-id"

// GIFT CARD USAGE
export const GET_ALL_GIFT_CARDS_USAGE = "admin/gift-cards-usage/all"
export const GET_GIFT_CARDS_USAGE_DETAILS = "admin/gift-cards-usage/details"

// SUBSCRIPTION / BILLING
export const GET_ALL_PLANS = "plans"
export const GET_PLAN_DETAILS = "plans/details"
export const GET_CURRENT_SUBSCRIPTION = "subscriptions/current"
export const GET_PLAN_HISTORY = "subscriptions/history"
export const CREATE_SUBSCRIPTION = "subscriptions/checkout"
export const UPGRADE_SUBSCRIPTION = "subscriptions/upgrade"
export const DOWNGRADE_SUBSCRIPTION = "subscriptions/downgrade"
export const CANCEL_SUBSCRIPTION = "subscriptions/cancel"
export const RENEW_SUBSCRIPTION = "subscriptions/renew"
export const GET_ALL_INVOICES = "invoices"
export const GET_INVOICE_DETAILS = "invoices/details"
export const DOWNLOAD_INVOICE = "invoices/download"
export const INITIATE_CHECKOUT = "billing/checkout/initiate"
export const VERIFY_PAYMENT = "subscriptions/checkout/verify"

// SUPERADMIN — TENANT MANAGEMENT
export const SA_GET_ALL_TENANTS = "superadmin/tenants/all"
export const SA_GET_TENANT_DETAILS = "superadmin/tenants/details"
export const SA_CREATE_TENANT = "superadmin/tenants/create"
export const SA_UPDATE_TENANT = "superadmin/tenants/update"
export const SA_UPDATE_TENANT_STATUS = "superadmin/tenants/status"
export const SA_GET_TENANT_INVOICES = "superadmin/tenants/invoices"
export const SA_GET_TENANT_SUBSCRIPTION = "superadmin/tenants/subscription"
export const SA_ASSIGN_TENANT_PLAN = "superadmin/tenants/assign-plan"
export const SA_TENANT_LOGIN = "superadmin/tenants/login"
export const SA_TENANT_MIGRATION_START = "superadmin/tenants/migration/start"
export const SA_TENANT_MIGRATION_STATUS = "superadmin/tenants/migration/status"
export const SA_TENANT_MIGRATION_CUTOVER = "superadmin/tenants/migration/cutover"

// SUPERADMIN — PLAN MANAGEMENT
export const SA_GET_ALL_PLANS = "superadmin/plans/all"
export const SA_GET_PLAN_DETAILS = "superadmin/plans/details"
export const SA_CREATE_PLAN = "superadmin/plans/create"
export const SA_UPDATE_PLAN = "superadmin/plans/update"
export const SA_DELETE_PLAN = "superadmin/plans/delete"
export const SA_UPDATE_PLAN_STATUS = "superadmin/plans/status"

// SUPERADMIN — BILLING OVERSIGHT
export const SA_GET_ALL_SUBSCRIPTIONS = "superadmin/billing/subscriptions"
export const SA_GET_ALL_INVOICES = "superadmin/billing/invoices"
export const SA_DOWNLOAD_INVOICE = "superadmin/billing/invoices/download"

// SUPERADMIN — INTEGRATIONS
export const SA_GET_ALL_INTEGRATION_CATEGORIES = "superadmin/integration-categories/all"
export const SA_GET_INTEGRATION_CATEGORY_DETAILS = "superadmin/integration-categories/details"
export const SA_CREATE_INTEGRATION_CATEGORY = "superadmin/integration-categories/create"
export const SA_UPDATE_INTEGRATION_CATEGORY = "superadmin/integration-categories/update"
export const SA_DELETE_INTEGRATION_CATEGORY = "superadmin/integration-categories/delete"
export const SA_UPDATE_INTEGRATION_CATEGORY_STATUS = "superadmin/integration-categories/status"

export const SA_GET_ALL_INTEGRATIONS = "superadmin/integrations/all"
export const SA_GET_INTEGRATIONS_CATALOG_TREE = "superadmin/integrations/catalog-tree"
export const SA_GET_INTEGRATION_DETAILS = "superadmin/integrations/details"
export const SA_CREATE_INTEGRATION = "superadmin/integrations/create"
export const SA_UPDATE_INTEGRATION = "superadmin/integrations/update"
export const SA_DELETE_INTEGRATION = "superadmin/integrations/delete"
export const SA_UPDATE_INTEGRATION_STATUS = "superadmin/integrations/status"

export const SA_GET_ALL_BRANDS = "superadmin/brands/all"
export const SA_GET_BRAND_LIST = "superadmin/brands/list"
export const SA_GET_BRAND_DETAILS = "superadmin/brands/details"
export const SA_ADD_BRAND = "superadmin/brands/add"
export const SA_UPDATE_BRAND = "superadmin/brands/update"
export const SA_DELETE_BRAND = "superadmin/brands/delete"
export const SA_TOGGLE_BRAND = "superadmin/brands/toggle"
export const SA_VERIFY_BRAND = "superadmin/brands/verify"
export const SA_GET_BRAND_NAMES_LIST = "superadmin/brands/brand-names/list"
export const SA_GET_BRAND_PAYMENT_METHODS = "superadmin/brands/payment-methods/list"
export const SA_GET_TENANT_FULFILLMENT_INTEGRATIONS = "superadmin/brands/fulfillment-integrations"
export const SA_GET_DELIVERY_PROFILE_TEMPLATES = "superadmin/brands/delivery-profile-templates"

// TENANT — INTEGRATIONS
export const TENANT_GET_INTEGRATION_CATEGORIES = "admin/integrations/categories"
export const TENANT_GET_INTEGRATIONS_CATALOG_TREE = "admin/integrations/catalog-tree"
export const TENANT_GET_AVAILABLE_INTEGRATIONS = "admin/integrations/available"
export const TENANT_GET_MY_INTEGRATIONS = "admin/integrations/my"
export const TENANT_GET_MY_INTEGRATION_DETAILS = "admin/integrations/my/details"
export const TENANT_CONNECT_INTEGRATION = "admin/integrations/connect"
export const TENANT_UPDATE_MY_INTEGRATION = "admin/integrations/my/update"
export const TENANT_DISCONNECT_MY_INTEGRATION = "admin/integrations/my/disconnect"
export const TENANT_DELETE_MY_INTEGRATION = "admin/integrations/my/delete"
export const TENANT_TEST_SMS_INTEGRATION = "admin/integrations/my/test-sms"
